
var isRoute=1;
let common = {
  prefix:isRoute==1?'/#':'',
  isRoute:isRoute,
  // 设置有参数url
  setUrl(url, data, isClear,isEncodeURI) {
    // 去除对象内多余的空值key
    if (isClear) {
      common.clearEmptyKey(data);
    }
    let dataStr = ""; //数据拼接字符串
    Object.keys(data).forEach(key => {
      if(isEncodeURI){
        dataStr += key + "=" + encodeURIComponent(data[key]) + "&";
      }
      else{
        dataStr += key + "=" + data[key] + "&";
      }
    });
    if (dataStr !== "") {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      // url有?
      if(url&&url.includes('?')){
        url = url + "&" + dataStr;
      }
      else{
        url = url + "?" + dataStr;
      }
    }
    return url;
  },
  
  // 去除对象内多余的空值key
  clearEmptyKey(data) {
    Object.keys(data).forEach(key => {
      if (
        data[key] === null ||
        data[key] === "" ||
        data[key] === undefined ||
        data[key] === "undefined"
      ) {
        delete data[key];
      }
    });
    return data;
  },
  
  // 判断对象是否为空
  ObjectEmpty(data) {
    return Object.keys(data).length === 0;
  },
  // 有重复不添加 key判断相同关键字 isCheck（2不需要）是否需要判断存在相同，isUnshift 往前添加还是往后添加
  removeSameArray(arr, row, key, isCheck,isUnshift) {
    //不需要判断存在相同
    if(isCheck==2){
      isUnshift?arr.unshift(row):arr.push(row);
    }
    else{    
      if (arr.length) {
          let hasSome = arr.some((item, index) => {          
            if(key){return item[key] == row[key];}
            else{return item.id == row.id;}      
          });
          if (!hasSome) {
            isUnshift?arr.unshift(row):arr.push(row);
          }
        } else {
          isUnshift?arr.unshift(row):arr.push(row);
        }
    }  
    return arr;
  },
  // 文件名打乱
  randomString(len) {
    len = len || 32;
    var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    var maxPos = chars.length;
    var pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  // 有值
  valuable(data) {
    if (
      data === null ||
      data === "" ||
      data === undefined ||
      data === "undefined"
    ) {
      return false
    }
    else{
     return true
    }
  },  
  typeOf(obj) {
      const toString = Object.prototype.toString;
      const map = {
          '[object Boolean]'  : 'boolean',
          '[object Number]'   : 'number',
          '[object String]'   : 'string',
          '[object Function]' : 'function',
          '[object Array]'    : 'array',
          '[object Date]'     : 'date',
          '[object RegExp]'   : 'regExp',
          '[object Undefined]': 'undefined',
          '[object Null]'     : 'null',
          '[object Object]'   : 'object'
      };
      return map[toString.call(obj)];
  },/**
 * 名称：deepCopy
 * 功能：深拷贝
 * 入口参数：data: 拷贝对象
 * 出口参数：拷贝后对象
 */
  deepCopy(data) {
      const t = common.typeOf(data);
      let o;
  
      if (t === 'array') {
          o = [];
      } else if ( t === 'object') {
          o = {};
      } else {
          return data;
      }
  
      if (t === 'array') {
          for (let i = 0; i < data.length; i++) {
              o.push(common.deepCopy(data[i]));
          }
      } else if ( t === 'object') {
          for (let i in data) {
              o[i] = common.deepCopy(data[i]);
          }
      }
      return o;
  }
}
export default common;

